<template>
	<div class="blockSpacList">
		<el-row type="flex" v-for="(item, index) in list" :key="index" class="blocK-list">
			<el-col v-for="(e, index) in item" :key="index">
				<span
					:class="[labelPosition == 'right' ? 'label-right' : null, 'label-position']"
					:style="{ width: labelWidth }"
					>{{ e.label }}</span
				>
				<span class="clearance"></span>
				<component
					:is="e.type"
					class="value"
					v-bind="e"
					v-on="$listeners"
					v-if="e.type"
				></component>
				<span v-else class="value">{{ e.value || '-' }}</span>
			</el-col>
		</el-row>
	</div>
</template>
<script>
export default {
	name: 'blockSpacList',
	props: {
		// label位置
		labelPosition: {
			type: String,
			default: 'right',
		},
		list: {
			type: Object,
		},
		// label宽度
		labelWidth: {
			type: String,
		},
	},
};
</script>
<style scoped lang="scss">
.blockSpacList {
  .el-col-24 > div {
    display: inline-block;
  }

  .label-position,
  .clearance {
    display: inline-block;
  }

  .label-right {
    text-align: right;
    width: 50%;
  }

  .blocK-list {
    padding: 5px 0;
  }

  .blocK-list > div {
    display: flex;
  }

  .clearance {
    width: 20px;
  }

  .value {
    flex: 1;
    width: 0;
  }
}
</style>
